// import { AluminiumBifoldDoor } from './aluminium-doors-step.js';

class ConfigurationPopup extends HTMLElement {
  constructor() {
    super();
    // Buttons / elements
    this.nextConfStepBtn = this.querySelector('#nextConfStepBtn');
    this.prevConfStepBtn = this.querySelector('#prevConfStepBtn');
    this.dialogCloseBtn = this.querySelector('.close-icon');

    // Buying journey
    this.buyingJourney = document.querySelector('buying-journey');
    this.aluminiumDoor = new AluminiumBifoldDoor();

    // State
    this.itemId = null;
    this.startStep = 0; // the initial dialog-id
    this.currentStep = 0; // current dialog-id
    this.totalSteps = 0; // number of steps to walk
    this.thresholdStep = 0; // startStep + totalSteps
    this.productType = null;
  }

  connectedCallback() {
    this._attachButtons();
  }

  _attachButtons() {
    // Prev
    this.prevConfStepBtn?.addEventListener('click', () => {
      if (this.currentStep > this.startStep) {
        this.currentStep--;
        this._switchDialogContent();
        this._updateNavButtons();
      }
    });

    // Close
    this.dialogCloseBtn?.addEventListener('click', () => {
      this._closeConfigurationDialog();
    });
  }

  openConfigurationDialog(option, itemId) {
    // Read initial dialog-id & step-count
    this.startStep = parseInt(option.dataset.dialogId, 10);
    this.currentStep = this.startStep;
    this.totalSteps = parseInt(option.dataset.stepCount, 10);
    this.thresholdStep = this.startStep + this.totalSteps;
    this.itemId = itemId;

    // Show first content
    this._switchDialogContent();
    this.style.display = 'block';
    this._updateNavButtons();
  }

  _updateNavButtons() {
    // ─── Prev button on/off ─────────────────────────────────────
    if (this.currentStep <= this.startStep) {
      this.prevConfStepBtn.classList.add('disabled');
    } else {
      this.prevConfStepBtn.classList.remove('disabled');
    }

    // ─── Next vs Update ────────────────────────────────────────
    if (this.currentStep >= this.thresholdStep) {
      // → SHOW “Update”
      this.nextConfStepBtn.innerHTML = `
        <button type="button" id="updateButton" class="step-button">
          <span>Update</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="21.5996" y="0.199219" width="21.6" height="21.6" rx="10.8"
                  transform="rotate(90 21.5996 0.199219)" fill="#FAFCFF"></rect>
            <path d="M9.83008 7.0625L13.7676 11L9.83008 14.9375" stroke="#29345A"
                  stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>`;
      this.nextConfStepBtn.querySelector('#updateButton').addEventListener('click', () => this._updateConfiguration());
    } else {
      // → SHOW “Next”
      this.nextConfStepBtn.innerHTML = `
        <button type="button" id="nextButton" class="step-button">
          <span>Next</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <rect x="21.5996" y="0.199219" width="21.6" height="21.6" rx="10.8"
                  transform="rotate(90 21.5996 0.199219)" fill="#FAFCFF"></rect>
            <path d="M9.83008 7.0625L13.7676 11L9.83008 14.9375" stroke="#29345A"
                  stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>`;
      this.nextConfStepBtn.querySelector('#nextButton').addEventListener('click', () => {
        this.currentStep++;
        this._switchDialogContent();
        this._updateNavButtons();
      });
    }
  }

  _switchDialogContent() {
    const product = this.buyingJourney.buyingJourneyProducts.find((item) => item.id === this.itemId);

    const dialogContent = this.buyingJourney.querySelector(`#step-${this.currentStep} .step-wrapper`);

    this.querySelector('.configuration-body').innerHTML = dialogContent?.innerHTML ?? 'Something went wrong…';

    // Re-hook up your productType logic
    this.productType = this.buyingJourney.getProductType(product.productType);
    this.productType.buyingJourneyObject = product;
    this.productType.target = this;
    this.productType.stepActions[this.currentStep - 1]();
  }

  _updateConfiguration() {
    // run the “post‐update” action (you may need to adjust the index math)
    this.productType.stepActions[this.totalSteps]();
    this.productType.buyingJourneyObject.totalPrice = this.productType.getProductFinalPrice();

    this.buyingJourney.renderQuoteItems([this.productType.buyingJourneyObject]);

    this._closeConfigurationDialog();
  }

  _closeConfigurationDialog() {
    this.style.display = 'none';
    this.itemId = null;
    // Reset to original buying‐journey view
    this.productType.stepActions[this.currentStep]();
    let itemsToRender = [this.productType.buyingJourneyObject];
    this.buyingJourney.renderQuoteItems(itemsToRender);
    this.buyingJourney.target = this.buyingJourney.selectedTemplate;
  }

  setDisableNextButton() {
    this.nextConfStepBtn.classList.add('disabled');
  }
  setActiveNextButton() {
    this.nextConfStepBtn.classList.remove('disabled');
    this.nextConfStepBtn.querySelector('span').textContent = 'Next';
  }

  setDisablePrevButton() {
    this.prevConfStepBtn.classList.add('disabled');
  }
  setActivePrevButton() {
    this.prevConfStepBtn.classList.remove('disabled');
  }
}

customElements.define('configuration-popup', ConfigurationPopup);
